import { jsx as _jsx } from "react/jsx-runtime";
import Script from 'next/script';
export const ConsentScript = ()=>/*#__PURE__*/ _jsx(Script, {
        async: true,
        "data-settings-id": process.env.NEXT_PUBLIC_USERCENTRICS_ID,
        id: "usercentrics-cmp",
        src: "https://web.cmp.usercentrics.eu/ui/loader.js"
    });

//# sourceMappingURL=ConsentScript.js.map